import DocumentReviewButton from '@/components/ui/DocumentReviewButton';

export type QualityCheckOptions = 'passed' | 'failed';

type QAIssueButtonsProps = {
  onQABtnClick: (type: QualityCheckOptions) => void;
};
export const QAIssueButtons: React.FC<QAIssueButtonsProps> = ({
  onQABtnClick,
}) => {
  return (
    <>
      <DocumentReviewButton
        id="1"
        initialLabel="Passed Quality Check"
        loadingLabel="Loading..."
        successLabel="Passed"
        colorClass="border-[1px] rounded-md text-[#20785C] border-[#20785C] h-10 w-1/2"
        successColorClass="border-[1px] rounded-md bg-[#E5F9F4] text-[#20785C] border-[#20785C] h-10 w-1/2"
        onClick={() => onQABtnClick('passed')}
      />
      <DocumentReviewButton
        id="2"
        initialLabel="Failed Quality Check"
        loadingLabel="Loading..."
        successLabel="Failed"
        colorClass="border-[1px] rounded-md text-[#CF0A0A] border-[#CF0A0A] h-10 w-1/2"
        successColorClass="border-[1px] rounded-md text-[#CF0A0A] border-[#CF0A0A] h-10 w-1/2"
        onClick={() => onQABtnClick('failed')}
        showLoader
      />
    </>
  );
};
